/*eslint-disable*/
export default {
    created () {
        this.declination = {
            admin: {
                add: this.$i18n.t('declination.declination_admin_add'),
                list: this.$i18n.t('declination.declination_admin_list'),
                'not exist': this.$i18n.t('declination.declination_admin_notExist')
            },
            teacher: {
                add: this.$i18n.t('declination.declination_teacher_add'),
                list: this.$i18n.t('declination.declination_teacher_list'),
                'not exist': this.$i18n.t('declination.declination_teacher_notExist')
            },
            student: {
                add: this.$i18n.t('declination.declination_student_add'),
                list: this.$i18n.t('declination.declination_student_list'),
                'not exist': this.$i18n.t('declination.declination_student_notExist')
            },
            school: {
                add: this.$i18n.t('declination.declination_school_add'),
                list: this.$i18n.t('declination.declination_school_list'),
                'not exist': this.$i18n.t('declination.declination_school_notExist')
            },
            transactions: {
                add: this.$i18n.t('declination.declination_school_add'),
                list: this.$i18n.t('declination.declination_transactions_list'),
                'not exist': this.$i18n.t('declination.declination_school_notExist')
            },
            grade: {
                add: this.$i18n.t('declination.declination_grade_add'),
                list: this.$i18n.t('declination.declination_grade_list'),
                'not exist': this.$i18n.t('declination.declination_grade_notExist')
            },
            course: {
                add: this.$i18n.t('declination.declination_course_add'),
                list: this.$i18n.t('declination.declination_course_list'),
                'not exist': this.$i18n.t('declination.declination_course_notExist')
            },
            homework: {
                add: this.$i18n.t('declination.declination_homework_add'),
                list: this.$i18n.t('declination.declination_homework_list'),
                'not exist': this.$i18n.t('declination.declination_homework_notExist')
            },
            'progress-homework': {
                add: this.$i18n.t('declination.declination_progressHomework_add'),
                list: this.$i18n.t('declination.declination_progressHomework_list'),
                'not exist': this.$i18n.t('declination.declination_progressHomework_notExist')
            },
            'progress-olympiad': {
                add: this.$i18n.t('declination.declination_progressOlympiad_add'),
                list: this.$i18n.t('declination.declination_progressOlympiad_list'),
                'not exist': this.$i18n.t('declination.declination_progressOlympiad_notExist')
            },
            'progress-battle': {
                add: this.$i18n.t('declination.declination_progressBattle_add'),
                list: this.$i18n.t('declination.declination_progressBattle_list'),
                'not exist': this.$i18n.t('declination.declination_progressBattle_notExist')
            },
            'points-history-homework': {
                list: this.$i18n.t('declination.declination_pointsHistoryHomework_list'),
                'not exist': this.$i18n.t('declination.declination_pointsHistoryHomework_notExist')
            },
            'points-history-olympiad': {
                list: this.$i18n.t('declination.declination_pointsHistoryOlympiad_list'),
                'not exist': this.$i18n.t('declination.declination_pointsHistoryOlympiad_notExist')
            },
            'points-history-battle': {
                list: this.$i18n.t('declination.declination_pointsHistoryBattle_list'),
                'not exist': this.$i18n.t('declination.declination_pointsHistoryBattle_notExist')
            },
            rating: {
                list: this.$i18n.t('declination.declination_rating_list'),
                'not exist': this.$i18n.t('declination.declination_rating_notExist')
            },
            'battle-rating': {
                list: this.$i18n.t('declination.declination_rating_list'),
                'not exist': this.$i18n.t('declination.declination_battleRating_notExist')
            },
            'homework-template': {
                list: this.$i18n.t('declination.declination_homeworkTemplate_list'),
                'not exist': this.$i18n.t('declination.declination_homeworkTemplate_notExist'),
                'add': this.$i18n.t('declination.declination_homeworkTemplate_add')
            },
            'lesson-conducting-template': {
                list: this.$i18n.t('declination.declination_lessonConductingTemplate_list'),
                'not exist': this.$i18n.t('declination.declination_lessonConductingTemplate_notExist'),
                add: this.$i18n.t('declination.declination_lessonConductingTemplate_add'),

            },
            'miles-history': {
                list: this.$i18n.t('declination.declination_milesHistory_list'),
                'not exist': this.$i18n.t('declination.declination_milesHistory_notExist')
            },
            'detective-points-history': {
                list: this.$i18n.t('declination.declination_detectivePointsHistory_list'),
                'not exist': this.$i18n.t('declination.declination_detectivePointsHistory_notExist')
            },
            stocks: {
                list: this.$i18n.t('declination.declination_stocks_list'),
                'not exist': this.$i18n.t('declination.declination_stocks_notExist'),
                'add': this.$i18n.t('declination.declination_stocks_add')
            },
            bonuses: {
                list: this.$i18n.t('declination.declination_bonuses_list'),
                'not exist': this.$i18n.t('declination.declination_bonuses_notExist'),
                'add': this.$i18n.t('declination.declination_bonuses_add')
            },
            'bonus-games': {
                list: this.$i18n.t('declination.declination_bonusGames_list'),
                'not exist': this.$i18n.t('declination.declination_bonusGames_notExist'),
                'add': this.$i18n.t('declination.declination_bonusGames_add')
            },
            'tariffs': {
                list: this.$i18n.t('declination.declination_tariffs'),
                'not exist': this.$i18n.t('declination.declination_tariffs_notExist'),
                'add': this.$i18n.t('declination.declination_tariffs_add')
            },
            subscriptions: {
                list: this.$i18n.t('declination.declination_subscriptions_list'),
                'not exist': this.$i18n.t('declination.declination_subscriptions_notExist'),
                'add': this.$i18n.t('declination.declination_subscriptions_add')
            },
            statistics: {
                list: this.$i18n.t('declination.declination_statistics_list'),
                'not exist': this.$i18n.t('declination.declination_statistics_list')
            },
            'payment-services': {
                list: this.$i18n.t('declination.declination_paymentServices_list'),
                'add': this.$i18n.t('declination.declination_paymentServices_add'),
                'not exist': this.$i18n.t('declination.declination_paymentServices_notExist')
            },
            'presentations': {
                list: this.$i18n.t('declination.declination_presentations_list'),
                'add': this.$i18n.t('declination.declination_presentations_add'),
                'not exist': this.$i18n.t('declination.declination_presentations_notExist'),
            },
            'presentations-theme': {
                list: this.$i18n.t('declination.declination_presentationsTheme_list'),
                'add': this.$i18n.t('declination.declination_presentationsTheme_add'),
                'not exist': this.$i18n.t('declination.declination_presentationsTheme_notExist')
            },
            'education-materials': {
                list: this.$i18n.t('declination.declination_presentationsTheme_list'),
                'add': this.$i18n.t('declination.declination_presentationsTheme_add'),
                'not exist': this.$i18n.t('declination.declination_presentationsTheme_notExist')
            }
        }
    },
}
